import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - USE YOUR ACTUAL VALUES

const firebaseConfig = {
  apiKey: "AIzaSyCOIYVTVopF2g_GLgxK8nKvUW8v3OfFUTM",
  authDomain: "bodlaleadcrm-4a566.firebaseapp.com",
  projectId: "bodlaleadcrm-4a566",
  storageBucket: "bodlaleadcrm-4a566.firebasestorage.app",
  messagingSenderId: "225947304185",
  appId: "1:225947304185:web:e0c0baf12ca49d1bbea228",
  measurementId: "G-4RLCHED1H5"
};
// Validate configuration
console.log('🔧 Initializing Firebase with project:', firebaseConfig.projectId);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);

console.log('✅ Firebase initialized successfully');

export { app, auth, db };